import { FC } from 'react';
import { BoxProps, Box } from '@mui/material';


type Props = BoxProps & {
  body: string;
}

export const StepBody: FC<Props> = ({ sx, body, ...props }) => {
  return (
    <Box
      color="text.secondary"
      whiteSpace="pre-wrap"
      sx={[{
        maxWidth: 500,
        lineHeight: '16px',
        '& p': { my: 0 },
        '& ul, & ol': { textAlign: 'left', pl: 2, my: 0 },
        '& li': { mb: 0 },
        '& strong': { fontWeight: 700 },
        '& em': { fontStyle: 'italic' },
        '& a': { color: 'primary.main' },
      }, ...(Array.isArray(sx) ? sx : [sx])]}
      dangerouslySetInnerHTML={{ __html: body }}
      {...props}
    />
  );
};